import { getConfig } from 'EnvConfig'
import { getPortalDomain } from 'utils/portal-config'

import { getPreviewTokenHeaders } from './preview-token'

export const primePortalPages = async (
  idToken: string,
  portalConfig: Record<string, unknown>
): Promise<unknown> => {
  const domain = getPortalDomain({
    domain: typeof portalConfig.domain === 'string' ? portalConfig.domain : '',
    epilot_domain:
      typeof portalConfig.epilot_domain === 'string'
        ? portalConfig.epilot_domain
        : ''
  })

  if (!domain) {
    throw new Error('portal domain missing')
  }

  const { CUSTOMER_PORTAL_API_URL } = getConfig()
  const url = new URL(`${CUSTOMER_PORTAL_API_URL}/v2/portal/pages`)

  url.searchParams.set('domain', domain)

  const response = await fetch(url.toString(), {
    method: 'GET',
    headers: {
      accept: 'application/json',
      authorization: `Bearer ${idToken}`,
      ...getPreviewTokenHeaders()
    }
  })

  if (!response.ok) {
    throw new Error(`portal pages ${response.status}`)
  }

  return response.json()
}
